module.exports = __webpack_public_path__ + "img/impact-center.fccd57ec.png";